module.exports = __webpack_public_path__ + "img/icon-shipping-gift.514be38b.svg";